export function preloadImages(urls) {
  const uniqueUrls = [...new Set(urls.filter(Boolean))];

  uniqueUrls.forEach((src) => {
    const image = new Image();
    image.src = src;
  });
}
